import React from 'react';
import CircularScore from 'components/pure/utils/CircularScore';
import './Summary.styl';

export default class Summary extends React.PureComponent {
  render() {
    const {scorecard, sessionUser} = this.props;
    const count = scorecard.results.count();
    const peopleString = count > 1 ? ' people' : ' person';
    const verb = count > 1 ? 'have' : 'has';
    const reviewedBySessionUser = scorecard.hasBeenReviewedBy(sessionUser.id);
    const includingYou = reviewedBySessionUser ? ', including you,' : '';
    const youAreOnlyReviewer = count === 1 && reviewedBySessionUser;
    return (
      <div className="scorecard-results-summary">
        <div className="score-container">
          <CircularScore
            className="circular-score"
            percentage={scorecard.getResultsAverageScore()}
          />
          <div className="label">Score</div>
        </div>
        <div className="call-info">
          {this.props.title}
          <div className="notice">
            {youAreOnlyReviewer
              ? 'You are the first to leave feedback '
              : `${count} ${peopleString}${includingYou} ${verb} left feedback `}
            on the call so far. Below are the results.
          </div>
        </div>
      </div>
    );
  }
}
